module.exports = __webpack_public_path__ + "static/media/Memb-I-00131_0041.61f6750c.jpg";